import { ReactNode } from 'react';
import * as Dialog from '@radix-ui/react-dialog';

import { cn } from '@components/primitives/utilities';

import css from './Drawer.module.css';

type DrawerTitleProps = {
  className?: string;
  children: ReactNode;
};

export default function DrawerTitle({ children, className }: DrawerTitleProps) {
  return (
    <Dialog.Title className={cn(css.title, className)}>{children}</Dialog.Title>
  );
}
